var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOldCarSides(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 2100 1422",
    id: "carChecklist",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.str1 {stroke:#373435;stroke-width:2.41048}\n\t\t\t.str2 {stroke:#00AFEF;stroke-width:2.41048}\n\t\t\t.str0 {stroke:#201E1E;stroke-width:2.41048}\n\t\t\t.str3 {stroke:#373435;stroke-width:0.918392}\n\t\t\t.fil9 {fill:none}\n\t\t\t.fil0 {fill:#E6E7E8}\n\t\t\t.fil10 {fill:#BDBFC1}\n\t\t\t.fil2 {fill:#A9ABAE}\n\t\t\t.fil5 {fill:#96989A}\n\t\t\t.fil12 {fill:#848688}\n\t\t\t.fil4 {fill:#4B4B4D}\n\t\t\t.fil1 {fill:#373435}\n\t\t\t.fil7 {fill:#FFF8AF}\n\t\t\t.fil11 {fill:#FFF688}\n\t\t\t.fil13 {fill:#F58634}\n\t\t\t.fil8 {fill:#ED3237}\n\t\t\t.fil3 {fill:#91D8F7}\n\t\t\t.fil6 {fill:#201E1E}\n\t\t"))), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 761,865 c 96,-6 188,-4 281,2 57,5 107,15 145,33 71,30 137,66 200,107 -7,5 -18,6 -30,5 -14,-14 -32,-24 -48,-35 -97,-64 -181,-94 -273,-97 -54,-3 -185,-1 -277,-1 l 2,-14 z",
    id: "path10",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 756,465 c 96,6 191,4 284,-2 57,-4 80,-8 146,-32 72,-30 137,-66 199,-107 -6,-5 -20,-6 -32,-5 -14,14 -30,23 -47,33 -123,76 -177,90 -274,97 -55,3 -185,0 -278,-1 l 2,17 z",
    id: "path12",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 650,876 c 44,-22 87,-28 130,-25 96,-3 191,-2 285,1 68,2 125,11 158,36 -12,1 -24,5 -36,12 -41,-17 -84,-28 -131,-32 -87,-6 -336,-14 -391,13 -1,-3 -6,-4 -15,-5 z",
    id: "path14",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 650,455 c 44,22 87,27 130,25 96,2 191,1 285,-2 68,-1 125,-10 158,-36 -12,-1 -24,-5 -36,-12 -41,17 -84,28 -131,32 -87,6 -336,15 -391,-13 -1,3 -6,5 -15,6 z",
    id: "path16",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gRodaDianteiraEsquerda",
    "data-id": "gRodaDianteiraEsquerda"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0 svg-part-car",
    "clicked-part": "PNEU",
    id: "pPneuDianteiroEsquerdo",
    style: {
      fill: "#373435",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    d: "m 1551,1 c 57,0 104,47 104,104 0,57 -47,103 -104,103 -57,0 -104,-46 -104,-103 0,-57 47,-104 104,-104 z m 0,31 c 40,0 73,32 73,73 0,40 -33,73 -73,73 -41,0 -73,-33 -73,-73 0,-41 32,-73 73,-73 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pRodaDianteiraEsquerda",
    r: 73,
    cy: 105,
    cx: 1551,
    className: "fil2 str0 svg-part-car",
    "clicked-part": "RODA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gRodaTraseiraEsquerda",
    "data-id": "gRodaTraseiraEsquerda"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373435",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPneuTraseiroEsquerdo",
    d: "m 636,2 c 57,0 104,46 104,103 0,58 -47,104 -104,104 C 579,209 533,163 533,105 533,48 579,2 636,2 Z m 0,30 c 41,0 73,33 73,73 0,41 -32,74 -73,74 -40,0 -73,-33 -73,-74 0,-40 33,-73 73,-73 z",
    className: "fil1 str0 svg-part-car",
    "clicked-part": "PNEU"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pRodaTraseiraEsquerda",
    r: 73,
    cy: 105,
    cx: 636,
    className: "fil2 str0 svg-part-car",
    "clicked-part": "RODA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gRodaDianteiraDireita",
    "data-id": "gRodaDianteiraDireita"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pRodaDianteiraDireita",
    r: 73,
    cy: 1226,
    cx: 1551,
    className: "fil2 str0 svg-part-car",
    "clicked-part": "RODA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373435",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPneuDianteiroDireito",
    d: "m 1551,1122 c 57,0 103,47 103,104 0,57 -46,104 -103,104 -58,0 -104,-47 -104,-104 0,-57 46,-104 104,-104 z m 0,31 c 40,0 73,32 73,73 0,40 -33,73 -73,73 -41,0 -74,-33 -74,-73 0,-41 33,-73 74,-73 z",
    className: "fil1 str0 svg-part-car",
    "clicked-part": "PNEU"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gRodaTraseiraDireita",
    "data-id": "gRodaTraseiraDireita"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pRodaTraseiraDireita",
    r: 73,
    cy: 1226,
    cx: 636,
    className: "fil2 str0 svg-part-car",
    "clicked-part": "RODA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373435",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPneuTraseiroDireito",
    d: "m 636,1123 c 57,0 103,46 103,104 0,57 -46,103 -103,103 -57,0 -104,-46 -104,-103 0,-58 47,-104 104,-104 z m 0,30 c 40,0 73,33 73,74 0,40 -33,73 -73,73 -41,0 -73,-33 -73,-73 0,-41 32,-74 73,-74 z",
    className: "fil1 str0 svg-part-car",
    "clicked-part": "PNEU"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gCapo",
    "data-id": "gCapo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pCapo",
    d: "m 1423,934 9,10 c 88,-1 180,-3 275,-14 63,-8 68,-14 89,-61 5,-22 10,-44 12,-67 6,-91 7,-185 1,-280 -4,-22 -9,-44 -16,-67 -12,-41 -30,-48 -65,-51 -97,-11 -197,-15 -295,-17 l -7,7 c 41,47 61,102 67,164 l 3,207 c -10,70 -29,131 -73,169 z",
    className: "fil0 str0 svg-part-car",
    "clicked-part": "CAPO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gVigia",
    "data-id": "gVigia"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVigia",
    d: "m 663,872 c -70,4 -146,11 -231,22 -32,-38 -45,-122 -48,-231 3,-109 16,-192 48,-230 85,11 161,18 231,22 -10,30 -14,60 -15,90 -2,39 -5,79 -4,118 -1,39 2,79 4,118 1,31 5,61 15,91 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIGIA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gTetoTopView",
    "data-id": "gTetoTopView"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pTetoTopView",
    d: "m 1226,721 c 1,-17 1,-34 1,-53 0,-72 -6,-145 -21,-218 -27,13 -59,19 -94,23 -108,5 -220,5 -332,3 -49,2 -89,-5 -117,-21 -9,30 -14,60 -15,90 -2,39 -5,79 -4,118 -1,39 2,79 4,118 1,31 6,61 15,91 28,-16 68,-23 117,-21 112,-2 224,-2 332,3 36,4 70,11 98,26 9,-53 14,-106 16,-159 z m -16,-273 0,-1 0,1 0,0 z",
    className: "svg-part-car",
    "clicked-part": "TETO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gPraraBrisa",
    "data-id": "gPraraBrisa"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPraraBrisa",
    d: "m 1426,394 -220,55 c 29,147 26,290 4,431 l 213,54 c 44,-38 63,-99 73,-169 l -3,-207 c -6,-62 -26,-117 -67,-164 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "PARA-BRISA"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil4 str0",
    d: "m 25,371 144,0 c -7,0 -13,2 -18,3 -5,3 -11,5 -13,11 -18,0 -34,1 -51,3 -9,10 -14,21 -6,36 7,5 12,14 14,25 l -70,0 C 12,449 2,438 2,425 l 0,-31 c 0,-13 10,-23 23,-23 z",
    id: "path44",
    style: {
      fill: "#4b4b4d",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 str0",
    d: "m 22,879 73,0 c -2,10 -5,18 -11,23 -11,14 -9,27 5,42 l 53,1 10,10 c 6,2 12,2 18,3 -1,0 -2,0 -3,0 L 22,958 C 11,958 1,949 1,937 l 0,-37 c 0,-11 10,-21 21,-21 z",
    id: "path46",
    style: {
      fill: "#4b4b4d",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueTraseiro",
    "data-id": "gParaChoqueTraseiro"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-CHOQUE TRASEIRO",
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueTraseiro",
    d: "m 228,478 0,-1 -8,3 -1,-87 0,0 0,0 -17,-8 0,-16 c -23,0 -39,1 -51,5 -5,3 -11,5 -13,11 -18,0 -34,1 -51,3 -9,10 -14,21 -6,36 13,9 18,28 15,55 11,136 10,265 0,388 -1,16 -4,29 -12,35 -11,14 -9,27 5,42 l 53,1 10,10 c 15,4 32,4 50,2 l 0,-15 17,-4 1,-86 0,0 c -6,-4 -10,-9 -9,-18 l 0,-167 0,0 0,0 0,-1 0,0 0,0 0,-167 c -1,-9 3,-15 9,-18 l 8,-3 z",
    className: "fil5 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gPortaMalas",
    "data-id": "gPortaMalas"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPortaMalasTop",
    d: "m 354,440 c 27,0 54,-2 78,-7 -32,38 -45,121 -48,230 3,109 16,193 48,231 -22,-3 -48,-5 -80,-6 -13,-56 -22,-124 -24,-207 4,-97 11,-183 26,-241 z",
    className: "fil0 str0 svg-part-car",
    "clicked-part": "PORTA-MALAS"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPortaMalasBack",
    d: "m 220,481 111,-43 c -2,76 -3,152 -3,228 0,77 1,153 3,229 L 220,852 c -6,-4 -10,-9 -9,-18 l 0,-167 0,0 0,0 0,-1 0,0 0,0 0,-167 c -1,-9 3,-15 9,-18 z",
    className: "fil0 str0 svg-part-car",
    "clicked-part": "PORTA-MALAS"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gPlacaTraseira",
    "data-id": "gPlacaTraseira"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPlacaTraseira",
    ry: 10,
    rx: 10,
    height: 196.05299,
    width: 49.958302,
    y: 567,
    x: 247,
    className: "fil2 str0 svg-part-car",
    "clicked-part": "PLACA TRASEIRA"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil6 str0",
    d: "m 1934,375 140,0 c 14,0 25,11 25,24 l 0,29 c 0,13 -11,24 -25,24 l -81,0 0,-52 c 0,-10 -3,-17 -12,-18 l -36,0 c -5,-3 -9,-5 -14,-7 1,0 2,0 3,0 z",
    id: "path54",
    style: {
      fill: "#201e1e",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gFarolEsquerdo",
    "data-id": "gFarolEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "FAROL ESQUERDO",
    style: {
      fill: "#fff8af",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pFarolEsquerdo",
    d: "m 1818,387 c 17,2 35,0 51,6 2,3 4,6 7,7 l 0,126 c -1,12 -9,13 -22,6 l -39,-24 -3,-114 c 0,-4 3,-7 6,-7 z",
    className: "fil7 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gLanternaTraseiraEsquerda",
    "data-id": "gLanternaTraseiraEsquerda"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pLanternaTraseiraEsquerda",
    className: "fil8 svg-part-car",
    d: "m 219,393 111,2 1,43 -111,42 -1,-87 z m 36,1 0,73 0,-73 z",
    "clicked-part": "LANTERNA TRASEIRA ESQUERDA"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil9 str0",
    d: "m 219,393 111,2 1,43 -111,42 -1,-87 z m 36,1 0,73",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "gLanternaTraseiraDireita",
    "data-id": "gLanternaTraseiraDireita"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "m 219,938 111,-1 1,-44 -111,-42 -1,87 z m 36,0 0,-74 0,74 z",
    id: "path65",
    style: {
      fill: "#ed3237"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "pLanternaTraseiraDireita",
    className: "fil9 str0 svg-part-car",
    d: "m 219,938 111,-1 1,-44 -111,-42 -1,87 z m 36,0 0,-74",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    "clicked-part": "LANTERNA TRASEIRA DIREITA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gFarolDireito",
    "data-id": "gFarolDireito"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff8af",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pFarolDireito",
    d: "m 1820,945 c 16,-1 31,0 48,-6 2,-5 5,-10 10,-14 l -1,-133 c -4,-9 -12,-9 -24,-1 l -37,26 -3,122 c 0,3 4,6 7,6 z",
    className: "fil7 str0 svg-part-car",
    "clicked-part": "FAROL DIREITO"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil6 str1",
    d: "m 2076,881 -84,0 0,59 c -2,6 -6,8 -13,8 l -34,0 c -4,4 -11,7 -18,9 l 149,0 c 13,0 23,-10 23,-23 l 0,-30 c 0,-13 -10,-23 -23,-23 z",
    id: "path71",
    style: {
      fill: "#201e1e",
      stroke: "#373435",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueDianteiro",
    "data-id": "gParaChoqueDianteiro"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-CHOQUE DIANTEIRO",
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueDianteiro",
    d: "m 1853,791 -38,26 c 4,-103 3,-204 -1,-309 l 40,24 c 13,7 21,6 22,-6 l 0,-126 c -4,-2 -7,-5 -9,-10 l 1,-20 c 26,-1 54,-4 77,12 l 36,0 c 9,1 12,8 12,18 l -1,540 c -2,6 -6,8 -13,8 l -34,0 c -11,9 -34,15 -69,16 -9,0 -8,1 -8,-8 l 0,-17 c 2,-5 5,-10 10,-14 l -1,-133 c -4,-9 -12,-9 -24,-1 z m 20,-77 c -2,30 -18,57 -48,65 5,-77 6,-156 1,-236 28,12 44,34 46,67 l 1,104 z",
    className: "fil5 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gGradeDianteira",
    "data-id": "gGradeDianteira"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbfc1",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pGradeDianteira",
    d: "m 1873,714 c -2,30 -18,57 -48,65 5,-77 6,-156 1,-236 28,12 44,34 46,67 l 1,104 z",
    className: "fil10 str0 svg-part-car",
    "clicked-part": "GRADE DIANTEIRA"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil4 str0",
    d: "m 1932,431 c 3,1 22,4 22,8 l 0,450 c -10,3 -33,18 -33,-3 l 0,-444 c 0,-6 5,-12 11,-11 z",
    id: "path77",
    style: {
      fill: "#4b4b4d",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gPlacaDianteira",
    "data-id": "gPlacaDianteira"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PLACA DIANTEIRA",
    style: {
      fill: "#a9abae",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pPlacaDianteira",
    d: "m 1899,565 22,0 0,195 -22,0 c -7,0 -12,-5 -12,-11 l 0,-173 c 0,-6 5,-11 12,-11 z",
    className: "fil2 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaLamasTraseiroDireito",
    "data-id": "gParaLamasTraseiroDireito"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-LAMAS TRASEIRO DIREITO",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaLamasTraseiroDireito",
    d: "m 800,1263 -41,0 c 7,-131 -80,-174 -161,-154 -5,1 -9,2 -13,4 l 0,0 -253,-2 0,0 c -1,-5 -1,-9 -2,-14 l 43,0 c 6,1 9,-2 7,-8 l -34,-86 -12,0 c 4,-4 8,-6 14,-8 l 89,1 c 60,-37 122,-69 185,-98 58,-24 88,-33 139,-31 l -2,12 -17,0 c -5,0 -9,2 -12,10 -13,38 -27,76 -38,114 l -10,16 c -9,18 -6,30 -6,44 1,19 9,33 24,43 48,30 69,70 67,117 0,13 7,19 18,19 l 13,0 2,21 z m -220,-259 96,2 45,-119 c -47,26 -92,44 -137,83 -14,11 -21,22 -4,34 z",
    className: "fil0 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaLamaTraseiroEsquerdo",
    "data-id": "gParaLamaTraseiroEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-LAMA TRASEIRO ESQUERDO",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaLamaTraseiroEsquerdo",
    d: "m 798,65 -41,0 c 7,132 -80,175 -162,155 -4,-1 -8,-2 -12,-4 l 0,0 -253,2 0,0 c -1,4 -1,9 -2,13 l 43,0 c 6,0 8,3 7,8 l -34,87 -12,0 c 4,3 8,6 14,7 l 89,0 c 60,37 122,69 185,98 58,24 89,33 139,34 l -2,-15 -17,0 c -5,0 -9,-3 -13,-10 -12,-38 -26,-77 -38,-114 l -10,-16 c -8,-19 -6,-30 -6,-44 1,-20 10,-34 25,-43 48,-30 68,-70 67,-118 0,-12 6,-18 18,-18 l 12,0 3,-22 z m -221,260 97,-3 45,120 c -47,-26 -92,-44 -137,-83 -14,-11 -21,-22 -5,-34 z",
    className: "fil0 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gFarolMilhaEsquerdo",
    "data-id": "gFarolMilhaEsquerdo"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff688",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pFarolMilhaEsquerdo",
    ry: 23,
    rx: 16,
    cy: 454,
    cx: 1937,
    className: "fil11 str0 svg-part-car",
    "clicked-part": "FAROL DE MILHA ESQUERDO"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "1354,88 1354,66 797,66 795,88 ",
    id: "polygon89",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path95",
    className: "fil9 str0",
    d: "m 742,879 244,0 22,130 c 14,84 19,163 6,233 l 22,0 -251,0 c -11,0 -18,-6 -18,-19 2,-47 -19,-87 -67,-117 -15,-10 -24,-24 -24,-43 0,-14 -3,-26 5,-44 l 10,-16 c 12,-38 26,-76 39,-114 3,-8 7,-10 12,-10 z m 8,10 220,-3 16,123 -273,0 1,-14 36,-106 z m 236,120 21,0",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path101",
    className: "fil9 str0",
    d: "m 740,450 244,0 22,-130 c 14,-84 19,-163 6,-233 l 22,0 -251,0 c -11,0 -18,6 -18,18 1,48 -19,88 -67,118 -15,9 -24,23 -24,43 -1,14 -3,25 5,44 l 10,16 c 12,38 26,76 38,114 4,7 8,10 13,10 z m 8,-10 220,3 16,-124 -273,1 1,14 36,106 z m 236,-121 21,0",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 1472,1010 c 132,16 310,43 328,81 -29,-11 -58,-18 -87,-18 -72,-15 -145,-29 -216,-35 -38,-3 -65,-10 -71,-21 2,0 4,-1 6,-1 15,-1 26,-3 40,-6 z",
    id: "path103",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "m 1472,323 c 132,-17 310,-44 328,-81 -29,10 -58,17 -87,17 -72,16 -145,29 -216,36 -38,3 -65,9 -71,21 2,0 4,0 6,0 15,1 26,3 40,7 z",
    id: "path105",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gParaLamaDianteiroDireito",
    "data-id": "gParaLamaDianteiroDireito"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaLamasDianteiroDireito",
    d: "m 1357,1012 c 14,1 25,0 30,-5 12,8 25,10 39,10 6,11 33,18 71,21 71,6 144,20 216,35 29,15 39,33 39,53 l -130,0 c -82,-45 -156,-30 -193,71 -2,21 -4,46 -4,67 l -68,0 0,-23 c 9,-3 15,-10 18,-19 8,-35 7,-103 1,-166 -1,-16 -6,-30 -19,-44 l 0,0 z",
    className: "fil0 str0 svg-part-car",
    "clicked-part": "PARA-LAMA DIANTEIRO DIREITO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gFarolMilhaDireito",
    "data-id": "gFarolMilhaDireito"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff688",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pFarolMilhaDireito",
    ry: 23,
    rx: 16,
    cy: 872,
    cx: 1938,
    className: "fil11 str0",
    "clicked-part": "FAROL DE MILHA DIREITO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path115",
    className: "fil9 str0",
    d: "m 1104,888 c -39,-7 -78,-9 -118,-9 l 22,130 c 14,84 19,163 6,233 l 338,0 c 12,-2 19,-9 23,-20 8,-35 7,-103 1,-166 -2,-22 -10,-41 -41,-62 -72,-46 -152,-94 -231,-106 z m -99,0 c 40,1 94,5 136,19 105,35 197,99 197,104 0,7 0,6 0,11 l -302,-13 -31,-121 z m 31,121 -28,0",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path121",
    className: "fil9 str0",
    d: "m 1102,441 c -39,7 -78,9 -118,9 l 22,-130 c 14,-84 19,-163 6,-233 l 338,0 c 12,2 19,9 23,20 8,35 7,102 1,165 -2,23 -10,42 -41,63 -72,46 -152,94 -231,106 z m -99,0 c 40,-1 94,-5 136,-19 105,-35 197,-99 197,-104 0,-7 0,-7 0,-11 l -302,13 -31,121 z m 31,-121 -28,0",
    style: {
      fill: "none",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaLamaDianteiroEsquerdo",
    "data-id": "gParaLamaDianteiroEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaLamaDianteiroEsquerdo",
    d: "m 1351,320 c 15,-1 31,1 36,5 12,-7 25,-10 39,-9 6,-12 33,-18 71,-21 71,-7 144,-20 216,-36 29,-14 39,-32 39,-52 l -130,-1 c -70,35 -156,31 -193,-71 -2,-20 -4,-46 -4,-66 l -68,-1 0,19 c 9,3 15,11 18,24 7,35 6,100 -1,163 -1,26 -23,46 -23,46 z",
    className: "fil0 str0 svg-part-car",
    "clicked-part": "PARA-LAMA DIANTEIRO ESQUERDO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gPortaDianteiraDireita",
    "data-id": "gPortaDianteiraDireita"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#e6e7e8",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    id: "pPortaDianteiraDireita",
    d: "m 1104,888 c -39,-7 -78,-9 -118,-9 l 22,130 c 14,84 19,163 6,233 l 338,0 c 12,-2 19,-9 23,-20 8,-35 7,-103 1,-166 -2,-22 -10,-41 -41,-62 -72,-46 -152,-94 -231,-106 z m -99,0 c 40,1 94,5 136,19 105,35 197,99 197,104 0,7 0,6 0,11 l -302,-13 -31,-121 z m 31,121 -28,0 28,0 z",
    className: "fil0 svg-part-car",
    "clicked-part": "PORTA DIANTEIRA DIREITA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroPortaDianteiraDireita",
    d: "m 1005,888 c 40,1 94,5 136,19 105,35 197,99 197,104 0,7 0,6 0,11 l -302,-13 -31,-121 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIDRO PORTA DIANTEIRA DIREITA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96989a",
      stroke: "#373435",
      strokeWidth: 2.41048002
    },
    id: "pRetrovisorDireito",
    d: "m 1269,965 c 25,14 61,36 69,46 l 0,11 -75,0 c -7,0 -12,-5 -12,-12 l 0,-27 c 0,-9 11,-23 18,-18 z",
    className: "fil5 str1",
    "clicked-part": "RETROVISOR DIREITO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gVidroTraseiroDireito",
    "data-id": "gVidroTraseiroDireito"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroTraseiroDireito",
    d: "m 580,1004 96,2 45,-119 c -47,26 -92,44 -137,83 -14,11 -21,22 -4,34 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIDRO"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gVidroTraseiroEsquerdo",
    "data-id": "gVidroTraseiroEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroTraseiroEsquerdo",
    d: "m 579,325 96,-3 45,120 c -47,-26 -92,-44 -137,-83 -14,-11 -21,-22 -4,-34 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIDRO TRASEIRO ESQUERDO"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "m 1187,900 c 11,-6 24,-11 39,-13 85,38 167,79 246,123 -14,3 -25,5 -40,6 -17,2 -34,-1 -49,-12 -63,-39 -127,-76 -196,-104 z",
    id: "path141",
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "m 1186,431 c 11,6 24,10 39,13 85,-38 167,-79 246,-123 -14,-4 -25,-5 -40,-7 -17,-2 -34,1 -49,12 -63,40 -127,77 -196,105 z",
    id: "path143",
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil12 str3",
    d: "m 1102,1051 -46,0 -20,0 c 0,3 5,10 14,12 6,0 7,1 18,1 7,-1 15,-1 23,-4 6,-2 11,-4 11,-9 0,-2 0,-4 -1,-6 -2,-4 -7,-5 -12,-5 -6,-1 -14,-2 -21,-2 -9,0 -18,0 -25,2 -4,1 -7,3 -7,6 -1,2 -1,4 0,5 l 66,0 z m -46,0 c 0,3 2,6 9,7 5,1 11,1 17,-1 6,-1 9,-3 9,-6 l -35,0 z m -9,1 c -2,0 -3,2 -3,4 0,2 1,4 3,4 3,0 4,-2 4,-4 0,-2 -1,-4 -4,-4 z m 9,-1 c 0,3 2,6 9,7 5,1 11,1 17,-1 6,-1 9,-3 9,-6 l -35,0 z m -9,1 c -2,0 -3,2 -3,4 0,2 1,4 3,4 3,0 4,-2 4,-4 0,-2 -1,-4 -4,-4 z",
    id: "path145",
    style: {
      fill: "#848688",
      stroke: "#373435",
      strokeWidth: 0.918392
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gPortaDianteiraEsquerda",
    "data-id": "gPortaDianteiraEsquerda"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#e6e7e8",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    id: "pPortaDianteiraEsquerda",
    d: "m 1102,441 c -39,7 -78,9 -118,9 l 22,-130 c 14,-84 19,-163 6,-233 l 338,0 c 12,2 19,9 23,20 8,35 7,102 1,165 -2,23 -10,42 -41,63 -72,46 -152,94 -231,106 z m -99,0 c 40,-1 94,-5 136,-19 105,-35 197,-99 197,-104 0,-7 0,-7 0,-11 l -302,13 -31,121 z m 31,-121 -28,0 28,0 z",
    className: "fil0 svg-part-car",
    "clicked-part": "PORTA DIANTEIRA ESQUERDA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroPortaDianteiraEsquerda",
    d: "m 1003,441 c 40,-1 94,-5 136,-19 105,-35 197,-99 197,-104 0,-7 0,-7 0,-11 l -302,13 -31,121 z",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIDRO PORTA DIANTEIRA ESQUERDA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96989a",
      stroke: "#373435",
      strokeWidth: 2.41048002
    },
    id: "pRetrovisorEsquerdo",
    d: "m 1267,364 c 25,-14 61,-36 69,-46 l 0,-11 -75,0 c -7,0 -12,5 -12,12 l 0,27 c 0,9 11,22 18,18 z",
    className: "fil5 str1 svg-part-car",
    "clicked-part": "RETROVISOR ESQUERDO"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848688",
      stroke: "#373435",
      strokeWidth: 0.918392
    },
    id: "path147",
    d: "m 1100,278 -46,0 -21,0 c 1,-3 6,-10 15,-12 6,-1 7,-1 18,-1 7,0 15,1 22,4 7,2 12,4 12,9 0,2 0,4 -1,6 -2,3 -7,5 -12,5 -7,1 -14,1 -21,2 -9,0 -18,0 -25,-2 -4,-1 -7,-3 -8,-7 0,-1 0,-3 0,-4 l 67,0 z m -46,0 c 0,-3 2,-6 8,-7 6,-1 12,-1 18,0 6,2 9,4 8,7 l -34,0 z m -9,-1 c -2,0 -4,-2 -4,-4 0,-2 2,-4 4,-4 2,0 4,2 4,4 0,2 -2,4 -4,4 z m 9,1 c 0,-3 2,-6 9,-7 5,-1 11,-1 17,0 6,2 9,4 8,7 l -34,0 z m -9,-1 c -2,0 -4,-2 -4,-4 0,-2 2,-4 4,-4 2,0 4,2 4,4 0,2 -2,4 -4,4 z",
    className: "fil12 str3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GPortaTraseiraDireita",
    "data-id": "GPortaTraseiraDireita"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#e6e7e8",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    id: "pPortaTraseiraDireita",
    d: "m 742,879 244,0 22,130 c 14,84 19,163 6,233 l 22,0 -251,0 c -11,0 -18,-6 -18,-19 2,-47 -19,-87 -67,-117 -15,-10 -24,-24 -24,-43 0,-14 -3,-26 5,-44 l 10,-16 c 12,-38 26,-76 39,-114 3,-8 7,-10 12,-10 z m 8,10 220,-3 16,123 -273,0 1,-14 36,-106 z m 236,120 21,0 -21,0 z",
    className: "fil0 svg-part-car",
    "clicked-part": "PORTA TRASEIRA DIREITA"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroPortaTraseiraDireita",
    points: "986,1009 713,1009 714,995 750,889 970,886 ",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIRDO PORTA TRASEIRA DIREITA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848688",
      stroke: "#373435",
      strokeWidth: 0.918392
    },
    id: "path149",
    d: "m 774,1049 -46,0 -21,0 c 1,3 5,11 15,12 6,1 7,1 17,1 8,0 15,-1 23,-3 7,-2 11,-5 12,-10 0,-2 0,-3 -1,-5 -2,-4 -7,-5 -12,-6 -7,-1 -14,-1 -21,-1 -9,-1 -18,0 -25,1 -5,1 -7,3 -8,7 0,2 0,3 0,4 l 67,0 z m -46,0 c 0,4 2,7 8,8 6,0 12,0 18,-1 6,-1 9,-3 8,-7 l -34,0 z m -9,1 c -2,0 -4,2 -4,4 0,2 2,4 4,4 2,0 4,-2 4,-4 0,-2 -2,-4 -4,-4 z m 9,-1 c 0,4 2,7 8,8 6,0 12,0 18,-1 6,-1 9,-3 8,-7 l -34,0 z m -9,1 c -2,0 -4,2 -4,4 0,2 2,4 4,4 2,0 4,-2 4,-4 0,-2 -2,-4 -4,-4 z",
    className: "fil12 str3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gPortaTraseiraEsquerda",
    "data-id": "gPortaTraseiraEsquerda"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#e6e7e8",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    id: "pPortaTraseiraEsquerda",
    d: "m 740,450 244,0 22,-130 c 14,-84 19,-163 6,-233 l 22,0 -251,0 c -11,0 -18,6 -18,18 1,48 -19,88 -67,118 -15,9 -24,23 -24,43 -1,14 -3,25 5,44 l 10,16 c 12,38 26,76 38,114 4,7 8,10 13,10 z m 8,-10 220,3 16,-124 -273,1 1,14 36,106 z m 236,-121 21,0 -21,0 z",
    className: "fil0 svg-part-car",
    "clicked-part": "PORTA TRASEIRA ESQUERDA"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pVidroPortaTraseiraEsquerda",
    points: "748,440 968,443 984,319 711,320 712,334 ",
    className: "fil3 str0 svg-part-car",
    "clicked-part": "VIDRO PORTA TRASEIRA ESQUERDA"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848688",
      stroke: "#373435",
      strokeWidth: 0.918392
    },
    id: "path151",
    d: "m 772,280 -46,0 -21,0 c 1,-3 5,-11 15,-12 5,-1 7,-1 17,-1 8,0 15,1 23,3 7,2 11,5 12,10 0,1 0,3 -1,5 -2,4 -7,5 -12,6 -7,1 -14,1 -21,1 -9,0 -18,0 -25,-1 -5,-1 -7,-4 -8,-7 0,-2 0,-3 0,-4 l 67,0 z m -46,0 c 0,-4 2,-7 8,-8 6,0 12,0 18,1 6,1 9,3 8,7 l -34,0 z m -9,-1 c -2,0 -4,-2 -4,-4 0,-2 2,-4 4,-4 2,0 4,2 4,4 0,2 -2,4 -4,4 z m 9,1 c 0,-4 2,-7 8,-8 6,0 12,0 18,1 6,1 9,3 8,7 l -34,0 z m -9,-1 c -2,0 -4,-2 -4,-4 0,-2 2,-4 4,-4 2,0 4,2 4,4 0,2 -2,4 -4,4 z",
    className: "fil12 str3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gLanternaDianteiraDireita",
    "data-id": "gLanternaDianteiraDireita"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f58634",
      stroke: "#373435",
      strokeWidth: 2.41048002
    },
    id: "pLanternaDianteiraDireita",
    d: "m 1713,1073 c 28,1 50,5 87,18 14,15 22,28 24,44 l -67,0 -5,-9 c 1,-26 -16,-41 -39,-53 z",
    className: "fil13 str1 svg-part-car",
    "clicked-part": "LANTERNA DIANTEIRA DIREITA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gLanternaDianteiraEsquerda",
    "data-id": "gLanternaDianteiraEsquerda"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f58634",
      stroke: "#373435",
      strokeWidth: 2.41048002
    },
    id: "pLanternaDianteiraEsquerda",
    d: "m 1713,260 c 28,-1 50,-5 87,-18 14,-16 22,-29 24,-44 l -67,0 -5,9 c 1,25 -16,41 -39,53 z",
    className: "fil13 str1 svg-part-car",
    "clicked-part": "LANTERNA DIANTEIRA ESQUERDA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueDianteiroDireito",
    "data-id": "gParaChoqueDianteiroDireito"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-CHOQUE DIANTEIRO",
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueDianteiroDireito",
    d: "m 1672,1263 c 7,-52 -4,-100 -50,-137 l 130,0 5,9 67,0 c 7,0 11,5 11,22 l 0,39 c -31,-3 -46,10 -44,38 l 34,0 c -1,4 0,9 -4,13 -8,8 -29,12 -53,16 l -96,0 z",
    className: "fil5 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueDianteiroEsquerdo",
    "data-id": "gParaChoqueDianteiroEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueDianteiroEsquerdo",
    d: "m 1672,69 c 7,53 -4,100 -50,138 l 130,0 5,-9 67,0 c 7,0 11,-5 11,-23 l 0,-38 c -31,2 -46,-10 -44,-39 l 34,1 c -1,-5 0,-9 -4,-13 -8,-8 -29,-13 -53,-17 l -96,0 z",
    className: "fil5 str0 svg-part-car",
    "clicked-part": "PARA-CHOQUE DIANTEIRO"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil8 str0",
    d: "m 333,325 11,0 34,-86 c 1,-6 -1,-8 -7,-8 l -43,0 -2,87 c 0,3 3,7 7,7 z",
    id: "path161",
    style: {
      fill: "#ed3237",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8 str0",
    d: "m 335,1004 11,0 34,86 c 1,5 -1,8 -7,8 l -43,0 -2,-87 c 0,-4 3,-7 7,-7 z",
    id: "path163",
    style: {
      fill: "#ed3237",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueTraseiroDireito",
    "data-id": "gParaChoqueTraseiroDireito"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-CHOQUE TRASEIRO",
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueTraseiroDireito",
    d: "m 585,1113 c -39,16 -81,64 -72,137 l -44,0 c -77,-17 -143,-2 -145,-28 -10,-8 -17,-19 -18,-35 -3,-14 -2,-29 0,-44 7,-13 16,-22 27,-29 l -1,-3 253,2 z",
    className: "fil5 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gParaChoqueTraseiroEsquerdo",
    "data-id": "gParaChoqueTraseiroEsquerdo"
  }, /*#__PURE__*/React.createElement("path", {
    "clicked-part": "PARA-CHOQUE TRASEIRO",
    style: {
      fill: "#96989a",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    },
    id: "pParaChoqueTraseiroEsquerdo",
    d: "M 583,216 C 543,200 502,152 510,79 l -43,0 c -77,16 -143,2 -145,28 -11,7 -17,19 -18,35 -3,14 -2,29 0,44 7,13 16,22 26,29 l 0,3 253,-2 z",
    className: "fil5 str0 svg-part-car"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "1357,1242 1357,1264 800,1264 798,1242 ",
    id: "polygon169",
    style: {
      fill: "#e6e7e8",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "m 384,996 53,0 c 93,-56 178,-98 228,-115 0,-2 -4,-4 -15,-5 -67,20 -145,53 -266,120 z",
    id: "path171",
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "m 379,334 54,0 c 93,55 178,97 228,114 -1,2 -4,4 -15,6 C 579,433 501,400 379,334 Z",
    id: "path173",
    style: {
      fill: "#91d8f7",
      stroke: "#201e1e",
      strokeWidth: 2.41048002
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldCarSides);
export default __webpack_public_path__ + "static/media/oldCarSides.00fd7697.svg";
export { ForwardRef as ReactComponent };